import CoreBase from '../../../../services/engines/CoreBase';
import templateEngine from '../TemplateEngine';

class TemplateLoader extends CoreBase {
    _name = 'TemplateLoader';

    /**
     * Loads a raw template note from the template engine by rk.
     * @param {string} rk
     * @returns {object|null} raw template note or null
     */
    load(rk) {
        if (!rk) return null;

        const note = templateEngine.getTemplate(rk);
        if (!note) {
            this.logError(`load: template not found — rk=${rk}`);
            return null;
        }

        return note;
    }
}

const templateLoader = new TemplateLoader();
export default templateLoader;
